var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 3.23858 13.2386 1 16 1H17C19.7614 1 22 3.23858 22 6V13C22 14.1046 21.1046 15 20 15H13C11.8954 15 11 14.1046 11 13V6Z",
    fill: "#FFADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10V7.5C8.5 6.5 9.2 4 12 4C14.8 4 15.5 6.5 15.5 7.5V10",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 10.75,
    width: 10.5,
    height: 8.5,
    rx: 1.25,
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15L12.0002 15.01",
    stroke: "#272932",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordBox);
export default __webpack_public_path__ + "static/media/Password Box.72ebfd0d22f63daa06adbcca22b3d176.svg";
export { ForwardRef as ReactComponent };